(function() {
  angular.module('screensApp').service('ScriptLoaderService', ['$window', '$q', function($window, $q) {
      var loadScript = function(src, scriptType = 'text/javascript') {
          var deferred = $q.defer();
          var script = $window.document.createElement("script");
          script.type = scriptType;
          script.src = src;
          script.onload = function() {
              deferred.resolve();
          };
          script.onerror = function() {
              deferred.reject(new Error('Failed to load script: ' + src));
          };
          $window.document.body.appendChild(script);
          return deferred.promise;
      };

      this.load = function(src, scriptType) {
          if (src && !isScriptLoaded(src)) {
              return loadScript(src, scriptType);
          }
      };

      var isScriptLoaded = function(src) {
          return $window.document.querySelectorAll('script[src="' + src + '"]').length > 0;
      };
  }]);
})();